import {KNOWN_TEMPLATES_BY_CHANNEL, TEMPLATES_BY_CHANNEL, TEMPLATE_IDS_BY_CHANNEL, RELEASES_SET_TEMPLATE_IDS} from "./templateManifest";
export {TEMPLATE_IDS_BY_CHANNEL, RELEASES_SET_TEMPLATE_IDS};
export const TEMPLATE_METADATA = TEMPLATES_BY_CHANNEL;
/**
 * Every design, on air or not, so that a saved grid and a preview can draw a
 * design that is not on air. `isCodeDefault`: code puts it on air; the Grid
 * offers only those (grid/catalog.ts).
 */
export const TEMPLATE_CATALOG = Object.entries(KNOWN_TEMPLATES_BY_CHANNEL).flatMap(([channel, entries]) => entries.map((entry) => ({
  ...entry, templateKey: `${channel}/${entry.id}${entries.filter((other) => other.id === entry.id).length > 1 ? `/${entry.key}` : ""}`,
  channel, templateId: entry.id,
  isCodeDefault: TEMPLATES_BY_CHANNEL[channel].includes(entry),
})));
export type TemplateDefinition = typeof TEMPLATE_CATALOG[number];
const byKey = new Map(TEMPLATE_CATALOG.map((entry) => [entry.templateKey, entry]));
export function getTemplateDefinition(templateKey: string): TemplateDefinition {
  const definition = byKey.get(templateKey);
  if (!definition) throw new Error(`Unknown template: ${templateKey}`);
  return definition;
}
